// Import html templates
import imagesModalTpl from 'app/common/partials/images/imagesModal.html';
import ImagesModalController from './imagesModal.controller';

export default function ImagesController($scope, $filter, imagesService, imagesHttpService, $uibModal, ivhTreeviewMgr) {
  var vm = this;
  vm.selectedCategories = imagesService.selectedCategories;
  vm.images = [];
  vm.filteredImages = [];
  vm.currentPage = 1;
  vm.itemsPerPage = 8;
  vm.paginationMaxSize = 3;
  vm.treeviewIcons = imagesService.treeviewIcons;
  vm.setPages = setPages;
  vm.openModal = openModal;
  vm.editSelectedCategories = editSelectedCategories;

  init();

  function init() {
    imagesService.getAllCategories().then(function(res) {
      vm.categories = res;
      vm.categoriesForModal = vm.categories;
    });
  }

  function editSelectedCategories(node, isSelected, tree) {
    var rootNode = 1;
    if (!node.selected) {
      imagesService.removeNodeFromSelected(node, tree);
      resetPages();
      getImages(vm.selectedCategories);
      return;
    }
    var hasParent = imagesService.getNodeParent(node);
    if (!hasParent) {
      ivhTreeviewMgr.deselectAll(tree);
      tree.forEach(function(node) {
        node.selected = false;
      });
    }
    node.children.forEach(function(subCategorie) {
      if (!vm.selectedCategories.includes(subCategorie.name)) {
        ivhTreeviewMgr.deselect(tree, subCategorie); //deselect because plugin select all nodes recusively.
      }
    });
    imagesService.addNodeToSelectedCategories(node, tree);
    getImages(vm.selectedCategories);
  }

  function getImages(categories) {
    if (!categories.length) {
      resetPages();
      return;
    }
    var categoriesIds = [];
    categoriesIds = getCategoriesId(categories);
    imagesHttpService.getImagesByCategories(categoriesIds).then(function(res) {
      if (res && res.data.length) {
        vm.images = res.data;
        setPages(vm.currentPage);
      }
    });
  }

  function getCategoriesId(categories) {
    var ids = [];
    categories.forEach(function(category) {
      ids.push(category.id);
    });
    return ids;
  }

  function setPages(page) {
    vm.filteredImages = $filter('unique')(vm.images, 'id');
    var pagedData = vm.filteredImages.slice((page - 1) * vm.itemsPerPage, page * vm.itemsPerPage);
    vm.paginImages = pagedData;
  }

  function resetPages() {
    vm.images = [];
    vm.paginImages = [];
    vm.filteredImages = 0;
    vm.currentPage = 1;
  }

  function openModal(modalPage, image) {
    vm.selectedCategories = angular.copy(vm.selectedCategories);
    vm.categories = angular.copy(vm.categories);
    var modalInstance = $uibModal
      .open({
        templateUrl: imagesModalTpl,
        controller: ImagesModalController,
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          openingPage: function() {
            return modalPage;
          },
          allCategories: function() {
            return vm.categoriesForModal;
          },
          getImageForEdit: function() {
            return image;
          },
        },
      })
      .result.finally(function() {
        vm.selectedCategories = imagesService.resetAll(vm.selectedCategories);
        resetPages();
        getImages(vm.selectedCategories);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/images/images.controller.js